import React from 'react'
import { Box, Skeleton } from '@mui/material'

const CouponTray = () => {
    return (
        <Box
            sx={{
                bgcolor: 'neutralColors.white',
                borderRadius: '11.2px',
                border: '1px solid',
                borderColor: 'borders.default',
                p: 2.1,
                mb: 3.5,
                width: '100%'
            }}
        >
            {/* Header */}
            <Skeleton variant="text" width={180} height={20} sx={{ mb: 2, mt: 0.5 }} />

            {/* Input and Apply button in a single box */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid',
                    borderColor: 'borders.heavy',
                    borderRadius: '7.7px',
                    px: 1.4,
                    py: 0.5,
                    width: '100%',
                    mb: 2.2,
                    bgcolor: 'neutralColors.white',
                    height: 39.3
                }}
            >
                <Skeleton variant="text" sx={{ flex: 1, height: 30.9 }} />
                <Skeleton variant="text" width={40} height={30.9} sx={{ ml: 1.4 }} />
            </Box>

            {/* Offers List with scrollable container */}
            <Box
                display="flex"
                flexDirection="column"
                gap={1.4}
                sx={{
                    maxHeight: 3 * 94.5 + 2 * 10,
                    overflowY: 'auto',
                    pr: 1
                }}
            >
                {[...Array(3)].map((_, index) => (
                    <React.Fragment key={index}>
                        <Box display="flex" flexDirection="column" gap={0.6} pb={1.4}>
                            {/* Offer Header with logo+code box and Apply button */}
                            <Box display="flex" alignItems="center" justifyContent="space-between" pb={1}>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1.4}
                                    bgcolor="#f1f6ff"
                                    borderRadius="7.7px"
                                    px={2.2}
                                    py={0.7}
                                >
                                    <Skeleton
                                        variant="rectangular"
                                        width={19.5}
                                        height={19.5}
                                        sx={{ borderRadius: 1 }}
                                    />
                                    <Skeleton variant="text" width={50} height={18} />
                                </Box>
                                <Skeleton variant="text" width={50} height={27.5} />
                            </Box>

                            {/* Discount Text */}
                            <Skeleton variant="text" width={120} height={16} sx={{ mb: 0.6 }} />

                            {/* Description with Know More */}
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <Skeleton variant="text" width={180} height={14} />
                                <Skeleton variant="text" width={70} height={14} />
                            </Box>
                        </Box>
                        {/* Divider (except for last item) */}
                        {index < 2 && (
                            <Box sx={{ borderBottom: '1px solid', borderColor: 'borders.default', my: 0.5 }} />
                        )}
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    )
}

export default CouponTray
